

export default {
    port: {
        login: {
            title: 'Login your account',
            username: 'username',
            password: 'password',
            save: 'Remember Me',
            login: 'Login',
            forget: 'Forgot Your Password?',
            password_login: 'Password login',
            vercode_login: 'Verification code login',
            login_now: 'Logging in, pleasewait...',
            phone_login: 'Login via mobilephone',
            mfa_verf: 'Pass security verification',
            mfa_phone_verf: 'Pass phone verification',
            phone_risk: 'A security risk has been detected on your account and your mobile phone number needs to be verified',
            input_textcode: 'Please enter the SMS verification code you received',
            input_phone: 'Enter the phone number',
            send_code: 'Send verification code',
            input_phone_code: 'Enter the phone verification code',
            change_verf_type: 'Use other validations',
            input_six_number: 'Please enter a 6-digit verification code',
            reset_password: 'Reset Passwords',
            choose_verf_type: 'Select validation type',
            phone_number: 'Cell-Phone Number',
            send_text_code: 'Send an SMS verification code',
            verfcode: 'Verification Code',
            short_text: 'Note',
            email_click_next: 'The email has been sent, please click the link in the email for further operation',
            reset_success: 'Reset successfully! Jump to the login page.',
            mfa_verfer: 'Verify by validators',
            input_mfa_verf_code: 'Please enter the verification code in the validator',
            input_verf_code: 'Input verification code',
            forget: 'Forgot Password?',
            email: 'Email',
            submit: 'Submit',
            social_login: 'Social account login',
            dingtalk: 'DingTalk',
            wechat: 'WeChat',
            qlinyun: 'Qlinyun',
            qlinyundev: 'Qlinyundev',
            bizark: 'Bizark'
        },
        reset: {
            title: 'Reset your account password',
            email: 'E-Mail Address',
            submit: 'Send Password Reset Link',
            password: 'password',
            repassword: 'Confirm password',
            reset: "Reset password",
        },
        profile: {
            title: 'User Profile',
            nick: 'Nickname:',
            email: 'Email:',
            ep: 'Edit Profile',
            submit: 'Submit',
            reset: 'Reset',
        },
        connections: {
            title: 'Social Account Binding',
            loading: 'Loading...',
            action_connect:'Connect',
            action_disconnect:'Disconnect',
            action_connect_success:'Connect Success',
            action_connect_failed:'Connect Failed: ',
            action_disconnect_success:'Disconnect Success',
            action_disconnect_failed:'Disconnect Failed: ',
            source_dingtalk:'DingTalk',
            source_wechat:'WeChat'
        },
        password: {
            title: 'User Password Update',
            nick: 'Nickname:',
            password: 'Current Password:',
            new_password: 'New Password:',
            re_password: 'Confirm Password:',
            same_password:'Confirm Password',
            submit: 'Update Password',
            home: 'Home',
            required:'This field is required.',
            rule:'It must contain at least 1 number, 1 letter, and the password length cannot be less than six digits'
        },
        panel_info:{
            info:'User Info',
            user:'Current User',
            ip:'Logon',
            attime:'Last Logon At',
            updated:'Last Change Password At',
        }
    }
}
